// extracted by mini-css-extract-plugin
export var centerText = "_5k-8";
export var container = "_5k-0";
export var doughnutContainer = "_5k-7";
export var legend = "_5k-a";
export var legendItemColorDisplay = "_5k-b";
export var legendItemLabel = "_5k-d";
export var legendItemValue = "_5k-c";
export var lg = "_5k-5";
export var maxWidth = "_5k-9";
export var md = "_5k-4";
export var responsive = "_5k-6";
export var sm = "_5k-3";
export var xs = "_5k-2";
export var xxs = "_5k-1";